import type { MarketingInsightsApi } from '../api/MarketingInsightsApi'
import type {
  TrendSeasonalityReportResponse,
  TrendSeasonalityRequestContext,
} from '../models/trendSeasonality.types'

import type { ReportDataLoadContext, ReportResponse } from '@/features/reports'

export interface LoadTrendSeasonalityFlowOptions {
  api: Pick<MarketingInsightsApi, 'getSeasonalityData'>
  context: () => TrendSeasonalityRequestContext | null
}

/** Runs the report-12 controller and seasonality sidecar as one abortable read transaction. */
export class LoadTrendSeasonalityFlow {
  constructor(private readonly options: LoadTrendSeasonalityFlowOptions) {}

  async execute(loadContext: ReportDataLoadContext): Promise<ReportResponse> {
    const context = this.options.context()
    if (!context) throw new TypeError('Trend seasonality request context is unavailable')
    const [report, seasonality] = await Promise.all([
      loadContext.load(),
      this.options.api.getSeasonalityData(context, loadContext.signal),
    ])
    const response: TrendSeasonalityReportResponse = {
      ...report,
      trend_seasonality: { seasonality },
    }
    return response
  }
}
